import * as React from 'react';
import { QuestionDto } from '../../../../pages/questionTypes';
import { translation } from '../../../../i18n';
import { AnswerDto, getEmptyAnswerDto } from '../../../../pages/answerTypes';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import OnFinishedTextField from '../../../OnFinishedTextField';
import { log } from '../../../../logConfig';
import { Grid } from '@material-ui/core';

interface Props {
  question: QuestionDto,
  existingAnswer?: AnswerDto,
  saveAnswer: (answer: AnswerDto) => void
}

@observer
class TextQuestion extends React.Component<Props> {

  @observable private answer: AnswerDto = getEmptyAnswerDto();

  constructor(props: Props) {
    super(props);

    this.answer.question = this.props.question;
    if (this.props.existingAnswer !== undefined) {
      this.answer.answer = this.props.existingAnswer.answer
    }
  }

  public render() {
    return (
      <Grid item={true} sm={12} md={8}>
        <OnFinishedTextField
          fullWidth={true}
          key={'text_question_input_answer' + this.props.question.id}
          id='text_question_input_answer'
          value={this.answer.answer}
          label={translation.t('answerComponent.answer')}
          onFinished={this.handleTextChange}
          multiline={true}/>
      </Grid>
    )
  }

  private handleTextChange = (value: string) => {
    log.info(value);
    this.answer.answer = value;
    this.props.saveAnswer(this.answer);
  };
}

export default TextQuestion;

